import React from 'react';
import { motion } from 'framer-motion';
interface ProductMockupProps {
  className?: string;
  maxWidth?: string;
}
export function ProductMockup({
  className = '',
  maxWidth = 'max-w-[420px]'
}: ProductMockupProps) {
  return <motion.div whileHover={{
    scale: 1.03,
    rotate: -1
  }} transition={{
    type: 'spring',
    stiffness: 300,
    damping: 20
  }} className={`relative mx-auto w-full ${maxWidth} ${className}`} data-id="element-62" data-mp="2olg1k7zlmwk4">
      {/* Drop shadow halo */}
      <div className="absolute -inset-4 bg-black/30 blur-2xl rounded-3xl transform translate-y-6 opacity-60 pointer-events-none" data-id="element-63" data-mp="3h6zectzuo417"></div>

      <img src="https://cdn.magicpatterns.com/uploads/217WksFhVRGb2oEoCqRCNE/mockup_definitivo.png" alt="Guía digital Alimentación Natural para tu perro y gato" className="relative w-full h-auto drop-shadow-2xl" data-id="element-64" data-mp="37acwme2tlt3e" />
    </motion.div>;
}